import React, { useState, useEffect } from "react";
import styles from "./UserProfile.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDetails } from "../../store/slice/features/authSlice";
import axios from "axios";
import { REACT_APP_API_URL } from "../../env";

const UserProfile = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    gender: "",
  });
  const [userAccount, setUserAccount] = useState(null);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  const { user } = useSelector((state) => state.auth);
  console.log("user data:", user);

  const dispatch = useDispatch();

  const sanitizeInput = (value) => {
    if (typeof value !== "string") return value;
    return value
      .replace(/<[^>]*>/g, "")
      .replace(/javascript:/gi, "")
      .replace(/on\w+=/gi, "")
      .trim();
  };


  useEffect(() => {
    dispatch(fetchUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (!user || !user.customerId) return;
    const fetchUserAccount = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}/api/my-account/user/account/${user.customerId}`
        );
        setUserAccount(response.data.data);
      } catch (error) {
      
        setUserAccount(null);
      }
    };
    fetchUserAccount();
  }, [user]);


  useEffect(() => {
    
    const src = userAccount || user;
    if (src) {
      setFormData((prev) => ({
        ...prev,
        name: src?.VisitorName || src?.customerName || "",
        email: src?.EmailId || src?.email || "",
        phone: src?.MobileNumber || src?.Mobile || src?.phone || "",
        address: src?.Address || src?.vchAddress || src?.address || "",
        gender: src?.Gender || src?.chrGender || src?.gender || "",
      }));
    }
  }, [userAccount, user]);
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = sanitizeInput(value);

    if (name !== "phone" && name !== "otp") {
      sanitizedValue = sanitizedValue.replace(/^\s+/, "");
    }

    if (name === "phone") {
      sanitizedValue = sanitizedValue.replace(/\D/g, "").slice(0, 10);
      setShowOtp(false);
      setOtpVerified(false);
      setOtp("");
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: sanitizedValue,
    }));

    if (message) setMessage("");
  };

  const handleOtpChange = (e) => {
    setOtp(sanitizeInput(e.target.value).replace(/\D/g, "").slice(0, 6));
  };

  const handleSendOtp = async () => {
    if (!/^\d{10}$/.test(formData.phone)) {
      setMessage("Please enter a valid 10-digit phone number.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/api/user/send-otp`,
        { phone: formData.phone },
        { withCredentials: true }
      );

      if (response.data.success) {
        setMessage("OTP sent successfully to your mobile number!");
        setShowOtp(true);
      } else {
        setMessage(response.data.message || "Failed to send OTP.");
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      setMessage(
        error.response?.data?.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!/^\d{4,6}$/.test(otp)) {
      setMessage("Please enter a valid OTP.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/api/user/verify-otp`,
        {
          phone: formData.phone,
          otp: otp,
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        setMessage(
          "OTP verified successfully! You can now update your profile."
        );
        setOtpVerified(true);
      } else {
        setMessage(response.data.message || "OTP verification failed.");
      }
    } catch (error) {
      console.error("Verify OTP error:", error);
      setMessage(
        error.response?.data?.message ||
          "OTP verification failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isPhoneEditable && formData.phone && !/^\d{10}$/.test(formData.phone)) {
      setMessage("Phone number must be exactly 10 digits.");
      return;
    }

    if (isPhoneEditable && formData.phone && !otpVerified) {
      setMessage("Please verify your phone number with OTP first.");
      return;
    }

    if (!formData.address.trim()) {
      setMessage("Address is required.");
      return;
    }

    if (!formData.gender) {
      setMessage("Gender is required.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const requestData = {
        address: formData.address.trim(),
        gender: formData.gender,
      };
      if (isPhoneEditable && formData.phone) {
        requestData.phone = formData.phone;
        requestData.otp = otp;
      }
      const response = await axios.put(
        `${REACT_APP_API_URL}/api/user/update/profile`,
        requestData,
        { withCredentials: true }
      );
      if (response.data) {
        setMessage("Profile updated successfully!");
        setShowOtp(false);
        setOtp("");
        setOtpVerified(false);
        dispatch(fetchUserDetails());
      }
    } catch (error) {
      console.error("Profile update error:", error);
      setMessage(
        error.response?.data?.message ||
          "Failed to update profile. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };


  const isNameEditable = !(userAccount?.VisitorName || user?.customerName);
  const isEmailEditable = !(userAccount?.EmailId || user?.EmailId);
  const isPhoneEditable = !(userAccount?.MobileNumber || user?.MobileNumber);
  const isAddressEditable = !(userAccount?.Address || user?.vchAddress);
  const isGenderEditable = !(userAccount?.Gender || user?.chrGender);
  const isProfileComplete =
    !!(userAccount?.MobileNumber || user?.MobileNumber) &&
    !!(userAccount?.Address || user?.vchAddress) &&
    !!(userAccount?.Gender || user?.chrGender);

  return (
    <div className={styles.container}>
      <aside className={styles.profileSidebar}>
        <svg
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.avatar}
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z"
              fill="#000000"
            ></path>
          </g>
        </svg>
        <h1 className={styles.email}>{user?.EmailId || ""}</h1>
      </aside>
      <main className={styles.profileFormWrapper}>
        {message && (
          <div
            className={`${styles.message} ${
              message.includes("success") ? styles.success : styles.error
            }`}
          >
            {message}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <section className={styles.formSection}>
            <h3 className={styles.sectionTitle}>Personal Details</h3>
            <div className={styles.formGrid}>
              <div className={styles.formGroup}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={isNameEditable ? handleChange : undefined}
                  placeholder="Enter your name"
                  readOnly={!isNameEditable}
                  disabled={!isNameEditable}
                  className={!isNameEditable ? styles.readOnlyField : ""}
                />
                <small className={styles.fieldNote}>
                  {isNameEditable ? "Name can be set only once" : "Name cannot be changed"}
                </small>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={isEmailEditable ? handleChange : undefined}
                  placeholder="Enter email ID"
                  readOnly={!isEmailEditable}
                  disabled={!isEmailEditable}
                  className={!isEmailEditable ? styles.readOnlyField : ""}
                />
                <small className={styles.fieldNote}>
                  {isEmailEditable ? "Email can be set only once" : "Email cannot be changed"}
                </small>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={isPhoneEditable ? handleChange : undefined}
                  placeholder="Enter phone number"
                  readOnly={!isPhoneEditable}
                  disabled={!isPhoneEditable}
                  className={!isPhoneEditable ? styles.readOnlyField : ""}
                />
                {!isPhoneEditable && (
                  <small className={styles.fieldNote}>
                    Phone number already set and cannot be changed
                  </small>
                )}
                {isPhoneEditable &&
                  /^\d{10}$/.test(formData.phone) &&
                  !showOtp &&
                  !otpVerified && (
                    <button
                      type="button"
                      className={styles.btn}
                      style={{ marginTop: 8 }}
                      onClick={handleSendOtp}
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send OTP"}
                    </button>
                  )}
                {isPhoneEditable && showOtp && !otpVerified && (
                  <div style={{ marginTop: 8 }}>
                    <input
                      type="text"
                      name="otp"
                      value={otp}
                      onChange={handleOtpChange}
                      placeholder="Enter OTP"
                      maxLength={6}
                      className={styles.otpInput || undefined}
                    />
                    <button
                      type="button"
                      className={styles.btn}
                      style={{ marginTop: 8, marginLeft: 8 }}
                      onClick={handleVerifyOtp}
                      disabled={loading || !otp}
                    >
                      {loading ? "Verifying..." : "Verify OTP"}
                    </button>
                  </div>
                )}
                {isPhoneEditable && otpVerified && (
                  <small
                    className={styles.fieldNote}
                    style={{ color: "#28a745" }}
                  >
                    ✓ Phone number verified successfully
                  </small>
                )}
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="gender">Gender</label>
                <select
                  id="gender"
                  name="gender"
                  value={formData.gender}
                  onChange={isGenderEditable ? handleChange : undefined}
                  disabled={!isGenderEditable}
                  className={!isGenderEditable ? styles.readOnlyField : ""}
                >
                  {(!formData.gender || formData.gender === "") && (
                    <option value="">Select Gender</option>
                  )}
                  <option value="m">Male</option>
                  <option value="f">Female</option>
                  <option value="o">Other</option>
                </select>
                {!isGenderEditable && (
                  <small className={styles.fieldNote}>
                    Gender already set and cannot be changed
                  </small>
                )}
              </div>
            
              <div className={styles.formGroup}>
                <label htmlFor="address">Address</label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={isAddressEditable ? handleChange : undefined}
                  placeholder="Enter your address"
                  rows={3}
                  disabled={!isAddressEditable}
                  className={!isAddressEditable ? styles.readOnlyField : ""}
                />
                {!isAddressEditable && (
                  <small className={styles.fieldNote}>
                    Address already set and cannot be changed
                  </small>
                )}
              </div>
            </div>
          </section>
          <div className={styles.formActions}>
           
            <button
              type="submit"
              className={
                `${styles.btn} ${styles.btnPrimary} ${(loading || isProfileComplete) ? styles.btnDisabled : ''}`
              }
              disabled={loading || isProfileComplete}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};

export default UserProfile;
